
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produto/[...produto]",
      function () {
        return require("private-next-pages/produto/[...produto].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/produto/[...produto]"])
      });
    }
  